import type * as React from 'react';
import { useTranslation } from 'next-i18next';
import type { FormLabelBase } from './form.types';
import { Text } from '@dx-ui/global-ui-prism';
import cx from 'classnames';

type FormLabelHelper = Pick<FormLabelBase, 'required' | 'optional' | 'hasError'>;

const FormLabelHelper: React.FC<React.PropsWithChildren<FormLabelHelper>> = ({
  required,
  optional,
  hasError,
}) => {
  const [t] = useTranslation('osc-form');
  const requiredText = required && t('required');
  const optionalText = optional && t('optional');

  const text = requiredText || optionalText;

  return text ? (
    <Text
      as="span"
      className={cx('ms-1 font-normal', {
        'text-surface-muted': !hasError,
        'text-surface-error': hasError,
      })}
    >
      ({text})
    </Text>
  ) : null;
};

export { FormLabelHelper };
export default FormLabelHelper;
